import React from "react";
import ConfigSection from "../../ConfigSection";

const PaymentTermsSection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Payment Terms Monthly'
      configType='PaymentTerms'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default PaymentTermsSection;
